import styled from '@emotion/styled';
import { Icon } from '@mdi/react';
import { BaseButton, Tooltip, Variables } from '../../base';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const Label = styled.div`
    font-family: 'Inter', ${Variables.Fonts.calibre};
    font-size: 12px;
    font-weight: ${Variables.FontWeight.semibold};
    color: ${Variables.Colors.slate500};
    text-transform: uppercase;
    letter-spacing: 0.6px;
    line-height: 16px;
`;

interface IWrapperProps {
    disabled?: boolean;
    isNote?: boolean;
}
export const Wrapper = styled.div<IWrapperProps>`
    display: flex;
    flex-grow: 1;
    position: relative;

    height: 192px;
    padding: 13px 17px;

    border: 1px solid ${Variables.Colors.slate300};
    border-radius: 8px;
    background-color: ${Variables.Colors.white};
    ${(props: IWrapperProps) =>
        props.disabled &&
        `
        border-color: ${Variables.Colors.n15};
        background-color: ${Variables.Colors.n15_24};
    `}
    ${(props: IWrapperProps) =>
        props.isNote &&
        `
        border-color: ${Variables.Colors.b300_l90};
        background-color: ${Variables.Colors.b300_l96};
        textarea {
            color:  ${Variables.Colors.b300_l62};
        }
    `}
`;
export const InnerCol = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;
export const Textarea = styled.textarea`
    background-color: transparent;
    border: 0;

    outline: none;
    flex-grow: 1;
    height: auto;
    font-size: 14px;
    line-height: 20px;

    min-height: 24px;
    resize: none;

    &::placeholder {
        color: ${Variables.Colors.slate400};
    }
`;
export const InputAttachments = styled.div`
    padding-top: 16px;
    margin-top: 8px;
    margin-bottom: 8px;
    border-top: 1px solid ${Variables.Colors.platinum};
`;
export const AttachInput = styled.input`
    display: none;
`;
export const AttachButton = styled(BaseButton)`
    padding: 0 4px;
    min-width: auto;
    background-color: transparent;
`;
export const AttachIcon = styled(Icon)`
    transform: rotate(45deg);
    vertical-align: middle;
    fill: ${Variables.Colors.n100};
`;
export const AttachTooltip = styled(Tooltip)`
    cursor: pointer;
`;

export const DragOverlay = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${Variables.Colors.nx16};
    color: ${Variables.Colors.b400};
    font-size: 16px;
    pointer-events: none;
    border-radius: 8px;
`;

export const Latin1Error = styled.div`
    display: flex;
    align-items: center;
    color: ${Variables.Colors.warning};
    font-size: 13px;
    font-weight: 500;
    margin-top: 4px;
`;

export const Latin1ErrorIcon = styled(Icon)`
    fill: ${Variables.Colors.warning};
    margin-right: 4px;
`;